import React from 'react';
import { useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { AddCircleOutline, RemoveCircleOutlineOutlined } from '@material-ui/icons';
import './style.scss';

const CnaeList = ({
  cnaelist,
  sort
}) => {
  const [selected, setselected] = useState({
    subclass: null,
    class: null,
    group: null,
    division: null,
    section: null
  });

  const changeselected = (type, value) => {
    let aux = { ...selected };
    let aux2 = { ...selected };
    switch (type) {
      case 'subclass':
        aux['subclass'] = value;
        break;

      case 'class':
        aux['class'] = value;
        aux['subclass'] = null;

        break;
      case 'group':
        aux['group'] = value;
        aux['class'] = null;
        aux['subclass'] = null;

        break;
      case 'division':
        aux['division'] = value;
        aux['group'] = null;
        aux['class'] = null;
        aux['subclass'] = null;

        break;
      case 'section':
        aux['section'] = value;
        aux['division'] = null;
        aux['group'] = null;
        aux['class'] = null;
        aux['subclass'] = null;

        break;
      default:
        break;
    }
    if (JSON.stringify(selected) === JSON.stringify(aux)) {
      aux2 = aux;
      aux2[type] = null;
      setselected({ ...aux2 });
    } else {
      setselected({ ...aux });
    }
  }

  const renderlist = (list) => {
    if (!cnaelist) return '';
    return Object.keys(list).sort(function (a, b) {
      if (sort === 'name') return 0;
      if (sort === 'value') return list[b].value - list[a].value;
      return 0
    }).map((a, k) => {
      return (
        <div key={k} style={{ border: ("1px solid #fff"), margin: "2px" }}
          className={"cnae-item rounded p-2 mb-2" + (
            selected[list[a].type] === a ? ' selected-cnae-item' : ''
          )}
        >
          <Row key={k} className="p-1" onClick={() => {
            changeselected(list[a].type, a);
          }}>
            <Col xs="auto"><p className="cnae-letter">{a}</p></Col>
            <Col style={{ fontSize: "12px", whiteSpace: "nowrap", overflowX: "hidden", padding: "0px", marginRight: "15px" }}>
              <p className="cnae-name mt-1">
                {list[a].name}
              </p>
            </Col>
            {list[a].type !== "subclass" &&
              <Col xs="1" className="mr-4 font-12">{selected[list[a].type] === a ?
                <RemoveCircleOutlineOutlined />
                :
                <AddCircleOutline />}
              </Col>
            }
          </Row>
          {list[a].value != null ? (
            <Row onClick={() => {
              changeselected(list[a].type, a);
            }}>
              <Col></Col>
              <Col xs="auto" className="pr-4"><p className="cnae-value m-1">{parseFloat(list[a].value).toLocaleString('PT-BR', { style: "currency", currency: "BRL" })}</p></Col>
            </Row>
          ) : (
            <Row onClick={() => {
              changeselected(list[a].type, a);
            }}>
              <Col></Col>
              <Col xs="auto" className="pr-4">
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </Col>
            </Row>
          )}
          {list[a].list ? (<>
            {selected[list[a].type] === a ? (
              <Row className="p-2">
                <Col xs="12">
                  {renderlist(list[a].list)}
                </Col>
              </Row>
            ) : ''}
          </>) : ''}
        </div>
      );
    });
  };

  return <div className="scroll" style={{ overflowY: "auto", overflowX: "hidden", height: "100%" }}>
    {renderlist(cnaelist)}
  </div>;

};

export default CnaeList;
